import { lazy, useEffect, useMemo } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { useAuth0, useAuth0Data } from 'neon-auth0';
import { baseUrls } from '../constants/urls';
import AcrRoutes from '../sites/acr/Routes';
import RlrRoutes from '../sites/limits/Routes';
import AsrRoutes from '../sites/asr/Routes';
import GrRoutes from '../sites/gr/Routes';
import CmrRoutes from '../sites/cmr/Routes';
import { checkIsMfaRequired, getMfaExpFromToken, isMfaTokenValid } from '../components/Auth/MfaConfig';
import { MFA_STORAGE_KEY, useMfa } from '../providers/MfaProvider';
import { Loader } from '../components/Loader/Loader';

const Home = lazy(() => import('../pages/Home/Home'));

const Routes = () => {
  const { pathname } = useLocation();

  const { accessToken } = useAuth0Data();
  const { error: errorAuthO, isLoading, isAuthenticated } = useAuth0();
  const { setIsMfa } = useMfa();

  const isMfaInToken = useMemo(() => isMfaTokenValid(accessToken), [accessToken]);
  const isMfaRequired = useMemo(() => checkIsMfaRequired(pathname), [pathname]);
  const isMfaValid = useMemo(() => (isMfaRequired ? isMfaInToken : true), [isMfaRequired, isMfaInToken]);

  useEffect(() => {
    if (checkIsMfaRequired(pathname) && isAuthenticated && !isLoading && !errorAuthO) {
      setIsMfa(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, accessToken, isAuthenticated, isLoading, errorAuthO]);

  useEffect(() => {
    if (accessToken) {
      const expTime = getMfaExpFromToken(accessToken);
      if (expTime) window.sessionStorage.setItem(MFA_STORAGE_KEY, expTime.toString());
    }
  }, [accessToken]);

  if (isMfaRequired && !isMfaValid) {
    return <Loader />;
  }

  return (
    <Switch>
      <Route path={baseUrls.home} exact={true} component={Home} />
      {AsrRoutes}
      {RlrRoutes}
      {AcrRoutes}
      {GrRoutes}
      {CmrRoutes}
      <Redirect to={baseUrls.home} />
    </Switch>
  );
};

export default Routes;
